import { v4 as uuidv4 } from "uuid";
import envService from "./envService";

const MICROFLOW_REST_URL: string = envService.getMicroflowRestUrl();
const PGD_APP_NAME: string = "NEB_CPS"; // Define your global app name here

interface RequestOptions {
  url: string;
  request: Record<string, any>;
  flowName: string;
  appName?: string;
  uniqueId: string;
  namerequest: string;
}

interface MicroflowResponse {
  responseStatus: string;
  responseCode?: string | null;
  responseMsg?: string | null;
  exception?: string;
  responseObjectsMap?: {
    OutputResponse?: {
      response?: string;
    };
  };
  [key: string]: any;
}

/**
 * Calls a microflow and returns the response.
 * @param requestJson - The request payload.
 * @param namerequest - The name of the request.
 * @param flowName - The name of the microflow.
 * @param uniqueId - A unique identifier for the request.
 * @param appname - The application name (optional).
 * @returns A promise resolving to the response from the microflow.
 */
async function req_microflow(
  requestJson: Record<string, any>,
  namerequest: string,
  flowName: string,
  uniqueId: string,
  appname?: string
): Promise<MicroflowResponse> {
  const url = MICROFLOW_REST_URL;
  const appName = appname || PGD_APP_NAME;

  try {
    const resp = await req_component_options({
      url,
      request: requestJson,
      flowName,
      appName,
      uniqueId,
      namerequest,
    });

    if (!resp || resp.responseStatus !== "SUCCESS") {
      throw new Error(
        resp?.exception || resp?.responseMsg || "Microflow request failed."
      );
    }

    return resp;
  } catch (error: any) {
    console.error("Microflow Error:", error);
    throw new Error(error.message || "Unknown microflow error");
  }
}

/**
 * Handles component options and sends a request.
 * @param options - Configuration options for the request.
 * @returns A promise resolving to the response from the request.
 */
async function req_component_options(
  options: RequestOptions
): Promise<MicroflowResponse> {
  const path = MICROFLOW_REST_URL;
  const {
    request,
    flowName,
    appName = PGD_APP_NAME,
    uniqueId,
    namerequest,
  } = options;

  const jsonObject = {
    flowName,
    appName,
    snapVersion: "v.1.0.0",
    uniqueId,
    object: { [namerequest]: request },
  };

  try {
    const response = await fetch_common(path, jsonObject);
    const res: MicroflowResponse = await response.json();

    if (res.responseStatus === "FAIL") {
      const errorMessage = res.exception || res.responseMsg || "Unknown error";
      // Swal.fire({
      //     title: 'Error!',
      //     text: errorMessage,
      //     icon: 'error',
      //     confirmButtonText: 'ปิด'
      // });
      throw new Error(errorMessage);
    }

    return res;
  } catch (error: any) {
    console.error("Fetch Error:", error);

    // Swal.fire({
    //     title: 'Error!',
    //     text: error.message || "Unknown error occurred",
    //     icon: 'error',
    //     confirmButtonText: 'ปิด'
    // });

    throw new Error(error.message || "Unknown fetch error");
  }
}

/**
 * Sends a POST request.
 * @param path - The request URL.
 * @param obj - The request payload.
 * @returns A promise resolving to the fetch response object.
 */
async function fetch_common(
  path: string,
  obj: Record<string, any>
): Promise<Response> {
  try {
    const bodyJson = JSON.stringify(obj);

    const response = await fetch(path, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: bodyJson,
    });

    console.log("responseData:", response);
    return response;
  } catch (error: any) {
    console.error("Fetch Request Error:", error);
    throw new Error(error.message || "Network request failed");
  }
}

const genUUID = (): string => {
  return uuidv4();
};

const checkEnLang = (lang: string): boolean => {
  if (lang === "en-EN" || lang === "en" || lang === "en-US") {
    return true;
  }
  return false;
};

const checkThLang = (lang: string): boolean => {
  if (lang === "th-TH" || lang === "th") {
    return true;
  }
  return false;
};

// Export as an object so it can be imported in Svelte files
export const commonUtil = {
  req_microflow,
  req_component_options,
  fetch_common,
  genUUID,
  checkEnLang,
  checkThLang,
};
